const EdtechIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15964_89419)">
      <path
        d="M29.9927 21.2412V11.2881L28.1177 11.9131V21.2412C26.9517 21.6338 26.1094 22.7366 26.1094 24.0331V29.054C26.1094 29.5717 26.5291 29.9915 27.0469 29.9915H31.0635C31.5812 29.9915 32.001 29.5717 32.001 29.054V24.0331C32.001 22.7366 31.1586 21.6338 29.9927 21.2412Z"
        fill="white"
      />
      <path
        d="M15.1094 15.6556L6.02344 12.627V19.0123C6.02344 19.261 6.12225 19.4995 6.29806 19.6753C8.88944 22.2663 12.3346 23.6933 15.9989 23.6933C19.6632 23.6933 23.1081 22.2663 25.6989 19.6751C25.8747 19.4993 25.9734 19.2609 25.9734 19.0123V12.627L16.8878 15.6555C16.2668 15.8623 15.6416 15.8329 15.1094 15.6556Z"
        fill="white"
      />
      <path
        d="M16 13.9248C16.1001 13.9248 16.2003 13.9088 16.2964 13.8767L31.3589 8.85591C31.7418 8.72829 32 8.37004 32 7.96654C32 7.56304 31.7418 7.20479 31.3589 7.07716L16.2964 2.05635C16.1041 1.99229 15.8959 1.99229 15.7036 2.05635L0.641062 7.07716C0.258188 7.20472 0 7.56297 0 7.96654C0 8.3701 0.258188 8.72829 0.641062 8.85591L15.7036 13.8767C15.7998 13.9088 15.8999 13.9248 16 13.9248Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15964_89419">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default EdtechIcon
